import { useReducer, useMemo } from 'react'
import { initialState } from './requestFilesForm/initialState.js'
import { requestFilesRootReducer } from './requestFilesForm/reducers/index.js'
import { useAuthActions } from './requestFilesForm/hooks/useAuthActions.js'
import { useEmailActions } from './requestFilesForm/hooks/useEmailActions.js'
import { useTemplateActions } from './requestFilesForm/hooks/useTemplateActions.js'
import { useSelectionActions } from './requestFilesForm/hooks/useSelectionActions.js'
import { useUIActions } from './requestFilesForm/hooks/useUIActions.js'

export function useRequestFilesForm(initialParams = {}) {
  const [state, dispatch] = useReducer(requestFilesRootReducer, initialState)

  const actions = useMemo(() => {
    const auth = useAuthActions(dispatch)
    const email = useEmailActions(dispatch)
    const template = useTemplateActions(dispatch)
    const selection = useSelectionActions(dispatch)
    const ui = useUIActions(dispatch)

    return {
      // Generic
      setField: ui.setField,
      initializeForm: ui.initializeForm,
      resetForm: ui.resetForm,

      // UI
      setSubmitting: ui.setSubmitting,
      setCopySuccess: ui.setCopySuccess,

      // Auth
      setAuthType: auth.setAuthType,
      setSecretQuestions: auth.setSecretQuestions,
      updateSecretQuestion: auth.updateSecretQuestion,

      // Selection
      setClient: selection.setClient,
      setSelectedFolder: selection.setSelectedFolder,

      // Email
      addRecipient: email.addRecipient,
      removeRecipient: email.removeRecipient,
      updateRecipient: email.updateRecipient,
      addReceiver: email.addReceiver,
      removeReceiver: email.removeReceiver,
      updateReceiver: email.updateReceiver,
      toggleSendEmails: email.toggleSendEmails,
      toggleReceiveEmails: email.toggleReceiveEmails,
      setEmailResults: email.setEmailResults,

      // Template / Task
      setRequestTemplate: template.setRequestTemplate,
      setTemplateDocuments: template.setTemplateDocuments,
      setDateRange: template.setDateRange,
      setDueDate: template.setDueDate,
      toggleDocumentSelection: template.toggleDocumentSelection,
      addOtherInput: template.addOtherInput,
      updateOtherInput: template.updateOtherInput,
      removeOtherInput: template.removeOtherInput,
      setPerDocumentDate: template.setPerDocumentDate,
      setPerOtherInputDate: template.setPerOtherInputDate,
      setSpecialInstructions: template.setSpecialInstructions,
      addAssignee: template.addAssignee,
      removeAssignee: template.removeAssignee,
      updateAssignee: template.updateAssignee,
      updateAssigneeField: template.updateAssigneeField,
    }
  }, [dispatch])

  return { state, actions }
}
